import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";
import getIsBenefitEventActive from "../selectors/getIsBenefitEventActive";
import setIsBenefitEventActive from "./setIsBenefitEventActive";

const loadLoyaltyIsBenefitEventActive = loyaltyBenefitType => async dispatch => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");
    const config = await loyaltySdk.getConfig();
    const isActive = getIsBenefitEventActive(config, loyaltyBenefitType);

    dispatch(setIsBenefitEventActive(isActive, loyaltyBenefitType));
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      error.message = `loadLoyaltyIsBenefitEventActive failed with error: ${error.message}`;
      logger.error(error);
    }
  }
};

export default loadLoyaltyIsBenefitEventActive;
